import { EditorContent } from "@tiptap/react";

export default function Editor({ editor }) {
  return <EditorContent style={{ width: "100%" }} editor={editor} />;
}
